import { jsx as r } from "react/jsx-runtime";
import { memo as d, forwardRef as m } from "react";
import { u as p } from "../styled-components.browser.esm-3eb04950.js";
import { isEmpty as a } from "../utils/object.utils.js";
const x = d(m(function({ html: i, padding: n, justifyContent: o = "center" }, e) {
  return /* @__PURE__ */ r(f, { ref: e, $padding: n, $justifycontent: o, dangerouslySetInnerHTML: { __html: i } });
})), f = p.div`
  line-height: 20px;
  min-height: 38px;
    padding: ${(t) => a(t.$padding) ? "12px" : `${t.$padding}px`};
  display: flex;
  flex-direction: column;
    justify-content: ${({ $justifycontent: t }) => t};
  height: 100%;
  
  img {
    width: 100%;
    padding-top: 3%;
  }
  
  p {
    margin-bottom: 0px;
    overflow-wrap: break-word;
  }
`;
export {
  x as default
};
//# sourceMappingURL=MdView.HtmlDiv.js.map
